const stripeMenu = {
  props: {
    dynamicClass: ".c-stripemenu.dynamicLoading",
    listAnchor: [],
    lastAnchor: null,
    className: ".c-stripemenu",
    classNameBg: "bg-b-blue",
    classNameText: "text-white",
    textimageIconSelector: ".c-stripemenu-textimage-icon-JS",
    buttonTextSimpleClass: "js-c-stripemenu__text-btn-smpl",
    wrapperSelector: ".c-stripemenu-wrapper-JS",
    nameAttrAnchorRef: "data-anchor-ref",
    offset: 151,
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-stripeMenu.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document;

    const $stripeMenu = baseFind.querySelector(this.props.className);
    let isSticky = false;

    if (!$stripeMenu) {
      return;
    }

    if (bcl.u.containsClass($stripeMenu, bcl.s.sticky.props.stickySelector)) {
      isSticky = true;
      window.addEventListener("scroll", this.windowScrollEvent.bind(this), false);
    }

    const components = document.querySelectorAll(this.props.className + " [" + this.props.nameAttrAnchorRef + "]");

    bcl.u.forEach(components, ($component) => {
      $component.addEventListener("click", () => {
        setTimeout(() => {
          bcl.s.dataAnchor.clickAnchor($component.getAttribute(this.props.nameAttrAnchorRef), -150);
        }, 500);
      });

      if (isSticky) {
        setTimeout(() => {
          this.initListAnchor($component);
        }, 1000);
      }
    });

    setTimeout(() => {
      this.scrollAnchorEvent();
    }, 1000);
  },

  initListAnchor: function ($component) {
    const $node = bcl.s.dataAnchor.getNodeAnchor($component.getAttribute(this.props.nameAttrAnchorRef));

    if ($node) {
      this.props.listAnchor.push({
        node: $component,
        top: bcl.s.dataAnchor.getScrollTop($node) - this.props.offset,
        titleNode: $node,
      });
    }
  },

  windowScrollEvent: function () {
    if (bcl.editMode) {
      return;
    }

    this.scrollAnchorEvent();
  },

  scrollAnchorEvent: function () {
    // TODO change for function utils
    const scroll = window.scrollY || document.documentElement.scrollTop,
      length = this.props.listAnchor.length;

    for (let i = 0; i < length; i++) {
      const top = bcl.s.dataAnchor.getScrollTop(this.props.listAnchor[i].titleNode) - this.props.offset,
        top1 = i != length - 1 && bcl.s.dataAnchor.getScrollTop(this.props.listAnchor[i + 1].titleNode) - this.props.offset;

      if (scroll < top) {
        this.deactiveNode(this.props.lastAnchor);
        this.props.lastAnchor = null;
      } else if (i === length - 1 || scroll < top1) {
        this.processNodeAnchor(i);
        break;
      }
    }
  },

  processNodeAnchor: function (i) {
    if (i !== this.props.lastAnchor) {
      this.activeNode(i);
      this.deactiveNode(this.props.lastAnchor);
      this.props.lastAnchor = i;
    }
  },

  activeNode: function (i) {
    if (isNaN(i) || !this.props.listAnchor[i] || this.props.listAnchor[i].node.disabled) {
      return;
    }

    const $node = this.props.listAnchor[i].node;

    if (bcl.u.containsClass($node, this.props.buttonTextSimpleClass)) {
      bcl.u.addClass($node, "--active");
    } else {
      bcl.u.addClass($node, this.props.classNameBg);
      bcl.u.addClass($node, this.props.classNameText);
      bcl.u.addClass($node, "bounce");
    }

    const $parent = $node.querySelector(this.props.textimageIconSelector);

    if ($parent && $parent.children.length > 1) {
      bcl.u.removeClass($parent.children[1], "hidden");
      bcl.u.addClass($parent.children[0], "hidden");
    }

    if (bcl.u.mobile.isMobile()) {
      const offset = bcl.u.getOffset($node),
        parent = $node.closest(this.props.wrapperSelector);

      if (offset.right > window.innerWidth) {
        bcl.u.goToWithScroll({
          node: parent,
          top: window.scrollY || document.documentElement.scrollTop,
          left: parent.scrollLeft + 150,
        });
      } else if (offset.left < 0) {
        bcl.u.goToWithScroll({
          node: parent,
          top: window.scrollY || document.documentElement.scrollTop,
          left: parent.scrollLeft - 150,
        });
      }
    }
  },

  deactiveNode: function (i) {
    if (isNaN(i) || !this.props.listAnchor[i]) {
      return;
    }

    const $node = this.props.listAnchor[i].node;

    if (bcl.u.containsClass($node, this.props.buttonTextSimpleClass)) {
      bcl.u.removeClass($node, "--active");
    } else {
      bcl.u.removeClass($node, this.props.classNameBg);
      bcl.u.removeClass($node, this.props.classNameText);
      bcl.u.removeClass($node, "bounce");
    }

    const $parent = $node.querySelector(this.props.textimageIconSelector);

    if ($parent && $parent.children.length > 1) {
      bcl.u.removeClass($parent.children[0], "hidden");
      bcl.u.addClass($parent.children[1], "hidden");
    }
  },
};

export default stripeMenu;
